export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13708.b90d65a9.jpg";